import { theme } from '@contrast-security-inc/design-system-foundations'
import { css } from '@emotion/css'
import React, { ReactNode } from 'react'
import { theme as deprecatedTheme } from '../../../../styled'
import { LibraryFormattedVersion } from '../library/library-formatted-version'
import { Severity, VulnerabilitySeverityBadge } from '../severity'
import { DrilldownLibrary } from '../../helpers/drilldown-ui-interfaces'
import { LibraryNameCellBase } from '../cell-content/name-cell'
import { useLibrariesPageContext } from '../../pages'
import { LibraryDetails } from '../library-details'

const smallScreenMediaQuery = '@media (max-width: 992px)'

interface Props {
  showWhiteBackgroundColor: boolean
  organizationID: string
  applicationID?: string
  library: DrilldownLibrary
  renderActions: ReactNode
}

export function DrilldownHeader({
  showWhiteBackgroundColor,
  organizationID,
  library,
  renderActions
}: Props) {
  const { isStaticGrid } = useLibrariesPageContext()

  const severity = !!library.severity
    ? Severity.fromName(library.severity)
    : null

  return (
    <div
      className={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <div
        className={css`
          display: flex;
          justify-content: space-between;
        `}
      >
        <div
          className={css`
            display: flex;
            flex-direction: column;

            padding-bottom: 5px;
            background-color: ${!!showWhiteBackgroundColor
              ? theme.color.white
              : 'initial'};
          `}
        >
          <div
            className={css`
              display: flex;
            `}
          >
            <div
              className={css`
                flex: 3;
                display: inline-flex;
                align-items: center;
                min-width: 0;
                transform: translateY(-3px);
              `}
            >
              {isStaticGrid && severity && (
                <div
                  className={css`
                    margin-right: 15px;
                  `}
                >
                  <VulnerabilitySeverityBadge severity={severity} />
                </div>
              )}
              <LibraryNameCellBase
                organizationID={organizationID}
                name={library.name}
                hash={library.hash}
                language={library.language}
                ossEnabled={library.ossEnabled}
                versions={library.versions}
                policies={library.policies}
                licenses={library.licenses}
                usage={isStaticGrid ? { totalUsed: 1 } : library.usage}
                className={css`
                  font-family: ${deprecatedTheme.fontFamilies.primary};
                  font-size: 21px;
                  font-weight: 500;
                  color: ${theme.color.neutral100};

                  white-space: nowrap;

                  margin: 0 10px 0 0;
                `}
              />
              <span>
                <LibraryFormattedVersion
                  version={library.versions.current.version}
                  language={library.language}
                />
              </span>
            </div>
          </div>
          <div
            className={css`
              display: flex;
              align-items: center;
            `}
          >
            <LibraryDetails
              library={library}
              className={css`
                margin: 0;
              `}
            />
          </div>
        </div>
        <div
          className={css`
            width: 75px;
            flex-shrink: 0;
            display: flex;
            justify-content: flex-end;
            margin-right: 20px;

            visibility: visible;
            ${smallScreenMediaQuery} {
              visibility: hidden;
            }
          `}
        >
          {renderActions}
        </div>
      </div>
    </div>
  )
}
